"use client";

import Image from "next/image";
import Link from "next/link";
import React from "react";

type LogoProps = {
  hideTitle?: boolean;
  size?: number;
  className?: string;
  imageClassName?: string;
  variant?: "icon" | "wordmark";
  href?: string;
};

const Logo = ({
  hideTitle,
  size = 80,
  className = "",
  imageClassName = "",
  variant = "icon",
  href,
}: LogoProps) => {
  const isWordmark = variant === "wordmark";
  const width = isWordmark ? Math.round(size * 3.75) : size;
  const height = size;
  const content = (
    <div
      className={`flex items-center justify-center sm:justify-start ${className}`}
      style={isWordmark ? { width, height, gap: size * 0.2, paddingInline: size * 0.2 } : undefined}
    >
      {isWordmark ? (
        <>
          <span
            className="relative block shrink-0 overflow-hidden"
            style={{ width: size * 0.55, height: size * 0.55 }}
          >
            <Image
              src="/landfast-logo.svg"
              width={Math.round(size * 0.8)}
              height={Math.round(size * 0.8)}
              alt=""
              style={{ width: size * 0.8, height: size * 0.8, maxWidth: "none" }}
              className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 ${imageClassName}`}
            />
          </span>
          <span
            className="whitespace-nowrap font-semibold leading-none tracking-[0.08em] text-slate-950 [font-family:var(--font-body)] dark:text-white"
            style={{ fontSize: size * 0.375 }}
          >
            LANDFAST
          </span>
        </>
      ) : (
        <Image
          src="/landfast-logo.svg"
          width={width}
          height={height}
          alt="Logo"
          style={{ width, height }}
          className={imageClassName}
        />
      )}
    </div>
  );

  if (!href) {
    return content;
  }

  return (
    <Link href={href} className="inline-flex">
      {content}
    </Link>
  );
};

export default Logo;
